module.exports = __webpack_public_path__ + "static/media/api-key.f43a1289.webp";